import React from 'react';
import { View, Text, Pressable } from 'react-native';
import moment from 'moment';

import colors from 'app/src/styles/colors';
import { Link } from 'app/src/utils/routing';
import { currency } from 'app/src/components/Sales/Process/currency';

import { Label } from './elements';

const SaleDetail = ({ asset, setShowModal, screenWidth }) => {
  if (!asset) { return null; }

  if (asset.soldOn) {
    const customerRefunds = asset.soldSaleAsset?.customerRefunds || [];

    return (
      <View>
        <View style={{display: 'flex', flexDirection: screenWidth < 992 ? 'column' : 'row '}}>
          <Label>
            Sold {moment(asset.soldOn).format('M/D/YY')}{' '}
            {currency(asset.soldAmount)}
          </Label>
          {asset.buyerWireOn ?
            <Label style={{color: colors.elGreen, fontWeight: 'bold'}}>
              {`(Paid - ${moment(asset.buyerWireOn).format('MM/DD/YY')})`}
            </Label> :
            null
          }
          {asset.fundedOn ?
            <Label style={{color: colors.elRed, fontWeight: 'bold'}}>
              {`(Seller Paid - ${moment(asset.fundedOn).format('MM/DD/YY')})`}
            </Label> :
            null
          }
        </View>
        {customerRefunds.map(refund => (
          <Link key={refund.id} to={`/accounting/transactions/${refund.id}`}>
            <Label style={{color: colors.elRed, fontWeight: 'bold'}}>
              {`REFUNDED - ${moment(refund.bankDate).format('MM/DD/YY')} `}
              {currency(refund.amount)}
            </Label>
          </Link>
        ))}
      </View>
    );
  }

  if (asset.activeSaleAsset) {
    return (
      <>
        <Text style={{fontWeight: 600}}>
          {asset.activeSaleAsset.correctedLotNumber}
          {' '}
          {moment(asset.activeSaleAsset.sale.saleOn).format('M/D/YY')}
        </Text>
        <Pressable onPress={() => setShowModal(asset.activeSaleAsset)}>
          <Text>{' '}+ Move to Sale</Text>
        </Pressable>
      </>
    );
  } else {
    return (
      <Pressable onPress={() => setShowModal(true)}>
        <Text>+ Add to Sale</Text>
      </Pressable>
    );
  }
};

export default SaleDetail;
